/** The server's row miniature (`BoardSummaryDto.thumbnail`, compact keys) as the elements `BoardThumbnailComponent` draws. */
export interface WireThumbnail {
  bounds: { minX: number; minY: number; maxX: number; maxY: number };
  shapes: { t: string; x: number; y: number; w: number; h: number; s?: string; b?: string; p?: [number, number][] }[];
}

const TYPE: Record<string, string> = { r: 'rectangle', d: 'diamond', e: 'ellipse', a: 'arrow' };
const NONE = { elements: [] as never[], bounds: null };

export function thumbnailElements(thumbnail: WireThumbnail | null | undefined): { elements: { id: string; type: string; x: number; y: number; width: number; height: number; points?: [number, number][]; strokeColor?: string; backgroundColor?: string }[]; bounds: WireThumbnail['bounds'] | null } {
  if (!thumbnail?.shapes?.length) return NONE;
  return {
    bounds: thumbnail.bounds,
    elements: thumbnail.shapes.map((shape, index) => ({ id: `t${index}`, type: TYPE[shape.t] ?? 'rectangle', x: shape.x, y: shape.y, width: shape.w, height: shape.h, points: shape.p, strokeColor: shape.s, backgroundColor: shape.b })),
  };
}
